import React from "react";
import {Container} from "semantic-ui-react";
import {LiveScoreGroup} from "../../../../store/pages/liveScoreInfo/types";
import "./styles.scss";


interface IPlayerLiveStatsPanelProps {
    statistics: LiveScoreGroup[];
}

export const PlayerLiveStatsPanel: React.FC<IPlayerLiveStatsPanelProps> = React.memo(({statistics}) => {
    return (
        <Container>
            {statistics?.map(stats => {
                return (
                    <Container className="section">
                        <div className={"boxWrapper"}>
                        <div className="section__title">{stats.name}</div>
                        {stats.items.map(item => {
                            return (
                                <div className="contentWrapper">
                                    <span>{item.name}</span>
                                    <span>{item.value}</span>
                                </div>
                            )
                        })}
                        </div>
                    </Container>
                )
            })}
        </Container>
    );
}, (prevProps, nextProps) => {
    return nextProps.statistics === prevProps.statistics;
})
